module.exports = __webpack_public_path__ + "img/Logo-8.c266c901.svg";